import React, { Component } from 'react';
import { Layout, Menu, Breadcrumb, Row, Col } from 'antd';
import TopBar from './TopBar';
import FootBar from './FootBar';

const { Header, Content, Footer } = Layout;

class MainLayout extends Component<{}, {}> {
	render() {
		return (
			<Layout>
				<TopBar />
				<Content className='basic-content'>{this.props.children}</Content>
				<Footer className='basic-footer'>
					<FootBar />
				</Footer>
			</Layout>
		);
	}
}

export default MainLayout;
